module.exports = __webpack_public_path__ + "static/favicon-8a714c5e7b8a8585dcc4ac29de3cfd67.png";